import { useCallback, useEffect, useRef, useState } from 'react'

export function useUserChatBubbleHover(moreMenuAnchor, reactionPickerAnchorEl) {
  const moreMenuOpenRef = useRef(false)
  const reactionPopoverOpenRef = useRef(false)
  const hoverCloseTimerRef = useRef(null)
  const hoverInFloatingRef = useRef(false)
  const [hoverInBubbleZone, setHoverInBubbleZone] = useState(false)

  useEffect(() => {
    moreMenuOpenRef.current = Boolean(moreMenuAnchor)
  }, [moreMenuAnchor])
  useEffect(() => {
    reactionPopoverOpenRef.current = Boolean(reactionPickerAnchorEl)
  }, [reactionPickerAnchorEl])

  const clearHoverCloseTimer = useCallback(() => {
    if (hoverCloseTimerRef.current) {
      window.clearTimeout(hoverCloseTimerRef.current)
      hoverCloseTimerRef.current = null
    }
  }, [])

  const scheduleHoverClose = useCallback(() => {
    clearHoverCloseTimer()
    hoverCloseTimerRef.current = window.setTimeout(() => {
      hoverCloseTimerRef.current = null
      if (!hoverInFloatingRef.current && !moreMenuOpenRef.current && !reactionPopoverOpenRef.current)
        setHoverInBubbleZone(false)
    }, 240)
  }, [clearHoverCloseTimer])

  useEffect(() => () => clearHoverCloseTimer(), [clearHoverCloseTimer])

  const bubbleZoneEnter = useCallback(() => {
    clearHoverCloseTimer()
    setHoverInBubbleZone(true)
  }, [clearHoverCloseTimer])

  const bubbleZoneLeave = useCallback(() => {
    scheduleHoverClose()
  }, [scheduleHoverClose])

  const floatingToolbarEnter = useCallback(() => {
    clearHoverCloseTimer()
    hoverInFloatingRef.current = true
    setHoverInBubbleZone(true)
  }, [clearHoverCloseTimer])

  const floatingToolbarLeave = useCallback(() => {
    hoverInFloatingRef.current = false
    scheduleHoverClose()
  }, [scheduleHoverClose])

  return { hoverInBubbleZone, bubbleZoneEnter, bubbleZoneLeave, floatingToolbarEnter, floatingToolbarLeave }
}
